import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { QcMerchantResponse } from 'src/app/shared/models/qcResponse.model';
import { Language, Region } from '../models/store.model';

export const OpenSidenav = createAction('[Store Management: Edit Store]: Open Sidenav');

export const CloseSidenav = createAction('[Store Management: Edit Store]: Close Sidenav');

export const CreateNew = createAction('[Store Management: Edit Store]: Create New');

export const InitPOSColumns = createAction(
  '[Store Management: Edit Store]: Init POS Columns',
  props<{ posDisplayedColumns: { [key: string]: string } }>(),
);

export const InitAttributeColumns = createAction(
  '[Store Management: Edit Store]: Init Attribute Columns',
  props<{ attributesDisplayedColumns: { [key: string]: string } }>(),
);

export const CodeChanged = createAction(
  '[Store Management: Edit Store]: Code Changed',
  props<{ code: string }>(),
);

export const CountryCodeChanged = createAction(
  '[Store Management: Edit Store]: Country Code Changed',
  props<{ countryCode: string }>(),
);

export const LanguagesChanged = createAction(
  '[Store Management: Edit Store]: Languages Changed',
  props<{ languages: Language[] }>(),
);

export const DisplayLanguageChanged = createAction(
  '[Store Management: Edit Store]: Display Language Changed',
  props<{ languageCode: string }>(),
);

export const SelectedLanguageChanged = createAction(
  '[Store Management: Edit Store]: Selected Language Changed',
  props<{ selectedLanguage: string }>(),
);

export const NameChanged = createAction(
  '[Store Management: Edit Store]: Name Changed',
  props<{ name: string }>(),
);

export const DescriptionChanged = createAction(
  '[Store Management: Edit Store]: Description Changed',
  props<{ description: string }>(),
);

export const AddPOSRow = createAction('[Store Management: Edit Store]: Add POS Row');

export const POSTableChanged = createAction(
  '[Store Management: Edit Store]: POS Table Changed',
  props<{ posData: string | number | null; index: number; column: string }>(),
);

export const DeletePOSRow = createAction(
  '[Store Management: Edit Store]: Delete POS Row',
  props<{ id: string }>(),
);

export const DeletePOSRowAll = createAction('[Store Management: Edit Store]: Delete POS Row All');

export const AddAttributeRow = createAction('[Store Management: Edit Store]: Add Attribute Row');

export const AttributeTableChanged = createAction(
  '[Store Management: Edit Store]: Attribute Table Changed',
  props<{ number: number | null; index: number; column: string }>(),
);

export const AttributeStringChanged = createAction(
  '[Store Management: Edit Store]: Attribute String Changed',
  props<{ text: string; index: number; column: string }>(),
);

export const AttributeBoolChanged = createAction(
  '[Store Management: Edit Store]: Attribute Bool Changed',
  props<{ index: number }>(),
);

export const DeleteAttributeRow = createAction(
  '[Store Management: Edit Store]: Delete Attribute Row',
  props<{ id: string }>(),
);

export const DeleteAttributeRowAll = createAction(
  '[Store Management: Edit Store]: Delete Attribute Row All',
);

export const DeactivateStoreChanged = createAction(
  '[Store Management: Edit Store]: Deactivate Store Changed',
);

export const AddressLineChanged = createAction(
  '[Store Management: Edit Store]: Address Line Changed',
  props<{ addressLine: string }>(),
);

export const TownChanged = createAction(
  '[Store Management: Edit Store]: Town Changed',
  props<{ town: string }>(),
);

export const CountryChanged = createAction(
  '[Store Management: Edit Store]: Country Changed',
  props<{ country: number; countryCode: string }>(),
);

export const CoordinatesChanged = createAction(
  '[Store Management: Edit Store]: Coordinates Changed',
  props<{ geoPoint: string }>(),
);

export const PostCodeChanged = createAction(
  '[Store Management: Edit Store]: Post Code Changed',
  props<{ postCode: string }>(),
);

export const RegionValuesChanged = createAction(
  '[Store Management: Edit Store]: Region Values Changed',
  props<{ regionValues: Region[] }>(),
);

export const RegionChanged = createAction(
  '[Store Management: Edit Store]: Region Changed',
  props<{ region: number }>(),
);

export const AddStoreGroups = createAction('[Store Management: Edit Store]: Add Store Groups');

export const AddStoreGroupsSuccess = createAction(
  '[Store Management: Edit Store]: Add Store Groups Success',
  props<{ res: QcResponseGrid }>(),
);

export const AddStoreGroupsFailed = createAction(
  '[Store Management: Edit Store]: Add Store Groups Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AddClubs = createAction('[Store Management: Edit Store]: Add Clubs');

export const AddClubsSuccess = createAction(
  '[Store Management: Edit Store]: Add Clubs Success',
  props<{ res: QcResponseGrid }>(),
);

export const AddClubsFailed = createAction(
  '[Store Management: Edit Store]: Add Clubs Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AddBrands = createAction('[Store Management: Edit Store]: Add Brands');

export const AddBrandsSuccess = createAction(
  '[Store Management: Edit Store]: Add Brands Success',
  props<{ res: QcResponseGrid }>(),
);

export const AddBrandsFailed = createAction(
  '[Store Management: Edit Store]: Add Brands Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AddCouponsets = createAction('[Store Management: Edit Store]: Add Couponsets');

export const AddCouponsetsSuccess = createAction(
  '[Store Management: Edit Store]: Add Couponsets Success',
  props<{ res: QcResponseGrid }>(),
);

export const AddCouponsetsFailed = createAction(
  '[Store Management: Edit Store]: Add Couponsets Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AddCouponsetsCountSuccess = createAction(
  '[Store Management: Edit Store]: Add Couponsets Count Success',
  props<{ totalResults: number }>(),
);

export const AddCouponsetsCountFailed = createAction(
  '[Store Management: Edit Store]: Add Couponsets Count Failed',
  props<{ error: HttpErrorResponse }>(),
);
export const AddUsers = createAction('[Store Management: Edit Store]: Add Users');

export const AddUsersSuccess = createAction(
  '[Store Management: Edit Store]: Add Users Success',
  props<{ res: any[] }>(),
);

export const AddUsersFailed = createAction(
  '[Store Management: Edit Store]: Add Users Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AddUsersCountSuccess = createAction(
  '[Store Management: Edit Store]: Add Users Count Success',
  props<{ totalResults: number }>(),
);

export const AddUsersCountFailed = createAction(
  '[Store Management: Edit Store]: Add Users Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const RemoveStoreGroups = createAction(
  '[Store Management: Edit Store]: Remove Store Groups',
);

export const RemoveClubs = createAction('[Store Management: Edit Store]: Remove Clubs');

export const RemoveStoreBrands = createAction(
  '[Store Management: Edit Store]: Remove Store Brands',
);

export const RemoveCouponsets = createAction('[Store Management: Edit Store]: Remove Couponsets');

export const RemoveUsers = createAction('[Store Management: Edit Store]: Remove Users');

export const RemoveStoreGroup = createAction(
  '[Store Management: Edit Store]: Remove Store Group',
  props<{ storeGroup: any }>(),
);

export const RemoveClub = createAction(
  '[Store Management: Edit Store]: Remove Club',
  props<{ club: any }>(),
);

export const RemoveStoreBrand = createAction(
  '[Store Management: Edit Store]: Remove Store Brand',
  props<{ brand: any }>(),
);

export const RemoveCouponset = createAction(
  '[Store Management: Edit Store]: Remove Couponset',
  props<{ couponSet: any }>(),
);

export const RemoveUser = createAction(
  '[Store Management: Edit Store]: Remove User',
  props<{ user: any }>(),
);

export const UpdateStore = createAction('[Store Management: Edit Store]: Update Store');

export const UpdateStoreSuccess = createAction(
  '[Store Management: Edit Store]: Update Store Success',
  props<{ res: QcMerchantResponse }>(),
);

export const UpdateStoreFailed = createAction(
  '[Store Management: Edit Store]: Update Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetStore = createAction(
  '[Store Management: Edit Store]: Get Store',
  props<{ storeID: string }>(),
);

export const GetStoreSuccess = createAction(
  '[Store Management: Edit Store]: Get Store Success',
  props<{ res: any[] }>(),
);

export const GetStoreFailed = createAction(
  '[Store Management: Edit Store]: Get Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SetMerchantID = createAction(
  '[Store Management: Add Store]: Set Merchant ID',
  props<{ merchantID: string }>(),
);

export const SearchMerchantByID = createAction(
  '[Store Management: Edit Store]: Search Merchant By ID',
);

export const SearchMerchantByIDSuccess = createAction(
  '[Store Management: Edit Store]: Search Merchant By ID Success',
  props<{ res: QcMerchantResponse }>(),
);

export const SearchMerchantByIDFailed = createAction(
  '[Store Management: Edit Store]: Search Merchant By ID Failed',
  props<{ error: HttpErrorResponse }>(),
);
